import {OrganizationDefaultSchemaCollaboratorsConfiguration} from 'auth/__generated/OrganizationDefaultSchemaCollaboratorsConfiguration';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {DefaultSchemaCollaboratorsConfigurationSchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Organization, OrganizationPermissionRole, Plan} from 'orgs/OrganizationConstants';
import {TeamPageOrganization} from 'orgs/TeamPage';
import {WRITE_POLICY} from 'test/fixtures/PolicyFixtures';
import pick from 'util/pick';

import {OrganizationGraphQL} from '../../../../graphql-fragments/parties/__generated/OrganizationGraphQL';

export const ORGANIZATION: Organization = {
  admin: true,
  adminGrantsTenantAdmin: true,
  allowNonadminsToSetOrgToOwnableOwner: true,
  autoEnablePlan: null,
  autoProvisionedCapabilities: [],
  avatar_url: '/static/img/no_avatar.jpg',
  disablePersonalOwnables: false,
  defaultOwnableMemberDataPolicyId: WRITE_POLICY.id,
  disablePublic: true,
  email: 'org@benchling.com',
  enableAdminView: true,
  handle: 'org-handle',
  id: 'ent_ORG_API_ID',
  institution: null,
  joinedOn: '2016-11-21T22:25:39.236826+00:00',
  location: 'san francisco',
  member: true,
  name: 'test org name',
  type: ModelTypeConstants.ORGANIZATION,
  url_identifier: 'test_org_name',
  urlIdentifier: 'test_org_name',
  website: 'https://wwww.website.com',
  permissions: {
    manageRoles: true,
  },
};

export const ORGANIZATION_GQL: OrganizationGraphQL = {
  __typename: 'OrganizationNode',
  id: ORGANIZATION.id,
  name: ORGANIZATION.name,
  handle: ORGANIZATION.handle,
  avatarUrl: ORGANIZATION.avatar_url,
  urlIdentifier: ORGANIZATION.url_identifier,
};

export const ORGANIZATION_WITH_ENTERPRISE_PLAN: Organization = {
  admin: true,
  adminGrantsTenantAdmin: true,
  allowNonadminsToSetOrgToOwnableOwner: true,
  autoEnablePlan: Plan.ELN_PRO,
  autoProvisionedCapabilities: [],
  avatar_url: '/static/img/no_avatar.jpg',
  disablePersonalOwnables: false,
  defaultOwnableMemberDataPolicyId: WRITE_POLICY.id,
  disablePublic: true,
  email: 'org@benchling.com',
  enableAdminView: true,
  handle: 'org-handle',
  id: 'ent_ORG_API_ID',
  institution: null,
  joinedOn: '2016-11-21T22:25:39.236826+00:00',
  location: 'san francisco',
  member: true,
  name: 'test org name',
  type: ModelTypeConstants.ORGANIZATION,
  url_identifier: 'test_org_name',
  urlIdentifier: 'test_org_name',
  website: 'https://wwww.website.com',
  permissions: {
    manageRoles: true,
  },
};

export const GQL_ORGANIZATION: TeamPageOrganization = pick(
  ORGANIZATION,
  'id',
  'name',
  'handle',
  'url_identifier',
  'admin',
  'member',
  'avatar_url',
  'disablePersonalOwnables',
  'email',
  'disablePublic'
);

export const ORGANIZATION_2: Organization = {
  ...ORGANIZATION,
  handle: 'org-2-handle',
  id: 'ent_ORG_API_ID_2',
  name: 'test org 2 name',
};

export const ORGANIZATION_2_GQL: OrganizationGraphQL = {
  __typename: 'OrganizationNode',
  id: ORGANIZATION_2.id,
  handle: ORGANIZATION_2.handle,
  name: ORGANIZATION_2.name,
  avatarUrl: ORGANIZATION_2.avatar_url,
  urlIdentifier: ORGANIZATION_2.url_identifier,
};

export const ORGANIZATION_WITH_INSTITUTION: Organization = {
  admin: false,
  adminGrantsTenantAdmin: true,
  allowNonadminsToSetOrgToOwnableOwner: true,
  autoEnablePlan: null,
  autoProvisionedCapabilities: [],
  avatar_url: 'https://imgur.com/img',
  disablePersonalOwnables: false,
  disablePublic: true,
  email: 'org@benchling.com',
  enableAdminView: true,
  handle: 'org-handle',
  member: false,
  id: 'ent_ORG_API_ID',
  institution: {
    fullName: 'Yale University',
    id: 'inst_Mw5Nmrjh',
    name: 'test institution name',
    names: ['Yale University', 'Yale', 'Yale University', 'Yale College', 'Yale'],
    shortName: 'Yale',
    subdomains: ['yale.edu', 'medicine.yale.edu'],
    urlIdentifier: 'yale',
    verified: true,
    licensed: false,
    hasUnlimitedSpace: false,
    grantsElnDesktopSync: false,
    enableExportNotifications: false,
    enableEmailChangeNotifications: false,
    adminEmail: '',
  },
  joinedOn: '2016-11-21T22:25:39.236826+00:00',
  location: 'san francisco',
  type: ModelTypeConstants.ORGANIZATION,
  name: 'test org name',
  url_identifier: 'test_org_with_institution_identifier',
  urlIdentifier: 'test_org_with_institution_identifier',
  website: 'https://wwww.website.com',
  permissions: {
    manageRoles: false,
  },
};

export const ORGANIZATION_DEFAULT_SCHEMA_COLLABORATORS: OrganizationDefaultSchemaCollaboratorsConfiguration =
  {
    __typename: 'OrganizationNode',
    id: 'org_id',
    name: 'Org',
    handle: 'orghandle',
    schemaCollaborationDefaultConfigurations: [
      {
        __typename: 'DefaultSchemaCollaboratorsConfigurationNode',
        schemaType: DefaultSchemaCollaboratorsConfigurationSchemaType.RUN,
        id: 'run_schema_default_id',
        defaultSchemaCollaborations: [],
      },
      {
        __typename: 'DefaultSchemaCollaboratorsConfigurationNode',
        schemaType: DefaultSchemaCollaboratorsConfigurationSchemaType.ENTITY,
        id: 'entity_schema_default_id',
        defaultSchemaCollaborations: [
          {
            __typename: 'DefaultSchemaCollaborationNode',
            policy: {__typename: 'SchemaPolicyNode', id: 'schema_read_id'},
            party: {__typename: 'OrganizationNode', handle: 'orghandle', id: 'org_id', name: 'Org'},
            organizationRole: OrganizationPermissionRole.ADMIN,
            teamRole: null,
          },
          {
            __typename: 'DefaultSchemaCollaborationNode',
            policy: {__typename: 'SchemaPolicyNode', id: 'schema_write_policy_id'},
            party: {__typename: 'UserNode', handle: 'userhandle', id: 'user_id', name: 'User'},
            organizationRole: null,
            teamRole: null,
          },
        ],
      },
    ],
  };
